module.exports = __webpack_public_path__ + "public/Icons/dashboard.svg?36d8ee01";